import { axiosClient } from "services/axios";

import { TReportsFilter } from "../../../types/reports";

export function getReportsProfitRequest(obj: TReportsFilter) {
  return axiosClient
    .post("reports/profit/", obj)
    .then((res) => {
      const data = res.data as { headers: any[]; tableData: any[] };
      data.tableData = data.tableData.map((i, index) => ({
        ...i,
        number: index + 1,
        salepercent:
          +i.cost123 !== 0
            ? (((+i.total12 - +i.cost123) / +i.cost123) * 100).toFixed(2)
            : "0.00",
        rentability:
          +i.total12 !== 0
            ? (((+i.total12 - +i.cost123) / +i.total12) * 100).toFixed(2)
            : "0.00",
      }));
      return data;
    })
    .catch((e) => {
      console.warn(e?.message, "while getting profit reports");
      return e?.response?.data;
    });
}

export function getReportsMovementRequest(obj: TReportsFilter) {
  return axiosClient
    .post("reports/movement/", obj)
    .then((res) => {
      const data = res.data as { headers: any[]; tableData: any[] };
      data.tableData = data.tableData.map((i, index) => ({
        ...i,
        number: index + 1,
      }));
      return data;
    })
    .catch((e) => {
      console.warn(e?.message, "while getting movement reports");
      return e?.response?.data;
    });
}
